import { Alert, Card } from 'corso-admin-ui';
import { Pegasus } from 'corso-types';
import { AutomationListByEventType } from '~/features/settings/automations/AutomationListByEventType';
import { ConfigurationAlert } from '~/features/settings/components/ConfigurationAlert';
import SettingsAnchorCard from '~/features/settings/components/SettingsAnchorCard';
import {
  useCheckoutPlusEmbed,
  useConfigSettings,
} from '~/hooks/useConfigSettings';
import { useIsStripeConnected } from '~/hooks/useIntegrationSettings';
import useIsCorsoAdmin from '~/hooks/useIsCorsoAdmin';

export default function ShopNow() {
  const { data } = useConfigSettings(
    ({ shippingProtection }) => shippingProtection,
  );

  const { data: checkoutPlusEmbed, isPending: isEmbedPending } =
    useCheckoutPlusEmbed();

  const isStripeConnected = useIsStripeConnected();
  const isCorsoAdmin = useIsCorsoAdmin();

  const isCheckoutScriptEnabled =
    data?.isCheckoutPlusScriptConfigured ||
    checkoutPlusEmbed?.isActive ||
    isCorsoAdmin;

  return (
    <SettingsAnchorCard id="shop-now">
      <Card.Heading>Shop Now</Card.Heading>
      {!isCheckoutScriptEnabled && !isEmbedPending && (
        <ConfigurationAlert
          variant="info"
          heading="Checkout Script Required"
          message="Enable Checkout Script in Checkout Plus Settings to configure Shop Now."
          to="../checkout-plus"
        />
      )}
      {!isStripeConnected && (
        <ConfigurationAlert
          variant="info"
          heading="Stripe Connection Required"
          message="Connect Stripe in your Integration settings to configure Shop Now."
          to="../integrations"
        />
      )}

      {isCheckoutScriptEnabled && isStripeConnected && (
        <>
          <Alert variant="info" heading="Shop Now is in Beta" />
          <AutomationListByEventType
            eventType={Pegasus.EventType.shopNow}
            hideIcon
          />
        </>
      )}
    </SettingsAnchorCard>
  );
}
